import { render, staticRenderFns } from "./comprehensiveQuery.vue?vue&type=template&id=6d0422d8&scoped=true&"
import script from "./comprehensive_query.js?vue&type=script&lang=js&"
export * from "./comprehensive_query.js?vue&type=script&lang=js&"
import style0 from "./comprehensiveQuery.vue?vue&type=style&index=0&id=6d0422d8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d0422d8",
  null
  
)

export default component.exports